/** @format */

import { RoomAvailability } from '../../@ducks/bookingNew/types';
import { TRoom } from '../../@ducks/room/declarations';

export const utilityFilterAvailabilityArray = (availabilityArray: Array<RoomAvailability>, list: Array<TRoom>) => {
  const filteredAvailabilityArray = availabilityArray.filter(el => {
    const found = list && list.find(element => element.code === el?.bedCode);
    return found;
  });
  return filteredAvailabilityArray;
};
